import React from 'react';

import {
  List,
  Datagrid,
  SimpleForm,
  TextField,
  Edit,
  Create,
  Show,
  SimpleShowLayout,
  translate as t,
  EditButton,
  ReferenceArrayInput,
  ChipField,
} from 'admin-on-rest';

import SelectArrayInput from '../components/inputs/SelectArrayInput';
import { PhoneNumberFieldInput } from '../components/inputs/PhoneNumberInput';

export const StudentList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="phoneNumber" />
      <EditButton />
    </Datagrid>
  </List>
));

const StudentTitle = ({ record }) => (
  <span>{record ? `${record.phoneNumber}` : ''}</span>
);

export const StudentCreate = t((props) => (
  <Create {...props}>
    <SimpleForm {...props}>
      <PhoneNumberFieldInput source="phoneNumber" />

      <ReferenceArrayInput key="books" label={props.translate('academy.book')} source="assignments" reference="books" allowEmpty>
        <SelectArrayInput optionText="title" options={{ fullWidth: true }} />
      </ReferenceArrayInput>

      <ReferenceArrayInput key="courses" label={props.translate('academy.course')} source="courses" reference="courses" allowEmpty>
        <SelectArrayInput optionText="title" options={{ fullWidth: true }} />
      </ReferenceArrayInput>

    </SimpleForm>
  </Create>
));

export const StudentEdit = t((props) => (
  <Edit title={<StudentTitle />} {...props}>
    <SimpleForm {...props}>
      <PhoneNumberFieldInput source="phoneNumber" />

      <ReferenceArrayInput label={props.translate('academy.book')} source="assignments" reference="books" allowEmpty>
        <SelectArrayInput optionText="title" options={{ fullWidth: true }} />
      </ReferenceArrayInput>

      <ReferenceArrayInput label={props.translate('academy.course')} source="courses" reference="courses" allowEmpty>
        <SelectArrayInput optionText="title" options={{ fullWidth: true }} />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
));

export const StudentShow = t((props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="phoneNumber" />
      <ChipField source="assignments" />
    </SimpleShowLayout>
  </Show>
));

